
const EpisodesHeader = () => {
  return (
    <section className="w-full bg-gradient-to-r from-teedee-blue to-bobo-green text-white">
      <div className="w-full py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold mb-8">
            Bobo & Teedee® Episodes
          </h1>
          <p className="text-xl lg:text-2xl max-w-4xl mx-auto opacity-90 leading-relaxed">
            Discover all our educational adventures! Each episode is designed to entertain, educate, and inspire children while celebrating Cayman Islands culture.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EpisodesHeader;
